<template>
  <div class="waitingcall">
    <router-view
      :ln="ln"
      :locale="locale"
      :isPublic="isPublic"
      :translateType="translateType"
      :info="info"
      :spaceCodeName="spaceCodeName"
      :activate="activate"
      :availableTime="availableTime"
      @refresh="init()" />
  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  name: 'Waitingcall',
  props: [
    'ln',
    'locale',
    'isPublic',
    'translateType'
  ],
  computed: {
    spaceCode () {
      const authInfo = this.$store.getters['authentication/getAuthInfo']
      return authInfo && authInfo.spaceCode
    },
    spaceCodeName () {
      const info = this.info && this.info.info
      const spaceCodeName = info && info.name[this.ln]
      return spaceCodeName || null
    }
  },
  watch: {
    async '$route' (to, from, next) {
      this.checkActivate()
      this.checkAvailableTime(to.name)
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      info: null,
      availableTime: {
        startTime: '0000',
        endTime: '2359'
      },
      activate: true
    }
  },
  methods: {
    getResultData (code) {
      return this.$store.getters['waitingcall/getWaitingcallResultData'](code)
    },
    async init () {
      const spaceCode = this.spaceCode
      if (spaceCode) {
        const infoData = await this.$store.dispatch('waitingcall/getWaitingcallData')
        const spaceCodeData = await this.$store.dispatch('waitingcall/getSpaceCodeSetting', spaceCode)
        const settingData = spaceCodeData && spaceCodeData.data && spaceCodeData.data.message
        const setting = settingData && settingData.settings
        this.activate = settingData && settingData.use
        if (spaceCodeData && settingData) {
          this.checkActivate()
          if (infoData && spaceCode) {
            this.info = infoData[spaceCode]
          }
          if (setting && setting.availableTime) {
            this.availableTime = setting.availableTime
          }
          this.checkAvailableTime(this.$route.name)
        } else {
          const errorCode = spaceCodeData && spaceCodeData.message && spaceCodeData.message.code || 500
          const errorMessage = this.getResultData(errorCode)
          const reason = spaceCodeData && spaceCodeData.message && spaceCodeData.message.reason
          alert(this.locale[`alert_waitingcall_${errorMessage}`] + (reason ? `\n${reason}` : ''))
          this.$store.commit('loading', false)
        }
      } else {
        alert(`missing spaceCode:\n${this.locale.access_correct_path}`)
        this.$router.replace({
          name: 'notfound'
        })
      }
    },
    checkActivate () {
      if (!this.activate) {
        this.$router.replace({
          name: 'waitingcallDisabled'
        })
      }
    },
    checkAvailableTime (routerName) {
      const startTime = numToHhmm(this.availableTime.startTime)
      const endTime = numToHhmm(this.availableTime.endTime)
      const isValidStart = moment().isSameOrAfter(moment().set({hour: startTime.hh, minute: startTime.mm, secound: 0}))
      const isValidEnd = moment().isSameOrBefore(moment().set({hour: endTime.hh, minute: endTime.mm, secound: 0}))
      const isAvailable = isValidStart && isValidEnd
      const isActivate = this.activate
      function numToHhmm (num) {
        return {
          hh: num.slice(0, 2),
          mm: num.slice(2, 4)
        }
      }
      if (routerName === 'waitingcallAuth' || routerName === 'waitingcallApply') { // 등록하려 할 때
        if (!isAvailable || !isActivate) { // 이용불가능한 시간 || 비활성화
          this.$router.replace({
            name: 'waitingcallDisabled'
          })
        }
      } else if (routerName === 'waitingcallDisabled') { // disabled 페이지에서
        if (isAvailable && isActivate) { // 이용가능한 시간 && 활성화
          this.$router.replace({
            name: 'waitingcallAuth',
            params: {
              ln: this.ln,
              nationality: 'domestic'
            }
          })
        }
      }
    }
  }
}
</script>
